import React, { useEffect, useState } from "react";
import { createAlbum } from "../../services/galleryService";
import { getAllPackages } from "../../services/paymentService";
import Button from "./Button";
import Input from "./Input";
import { toast } from "react-toastify";

const CreateAlbumModal = ({ galleryId, galleryName, onClose, onCreated }) => {
  const [form, setForm] = useState({
    name: "",
    IsPremium: false,
    PackageId: "",
    MakeGalleryPremium: false,
    IsWatermark: false,
    isFundraising: false,
    visibilityDelayHours: "",
    NotifyPromoterOnLive: false,
    NotifyUsersOnLive: false,
  });
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [packagesLoaded, setPackagesLoaded] = useState(false);

  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  useEffect(() => {
    if (!form.IsPremium || packagesLoaded || packagesLoading) return;

    const loadPackages = async () => {
      setPackagesLoading(true);
      try {
        const res = await getAllPackages();
        const raw = Array.isArray(res.data?.Result)
          ? res.data.Result
          : Array.isArray(res.data)
            ? res.data
            : [];
        setPackages(raw.filter((pkg) => pkg?.IsActive !== false));
        setPackagesLoaded(true);
      } catch (err) {
        toast.error(err.response?.data?.Message || "Failed to load package prices.");
      } finally {
        setPackagesLoading(false);
      }
    };

    loadPackages();
  }, [form.IsPremium, packagesLoaded, packagesLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.warning("Album name is required."); return; }
    if (form.IsPremium && !form.PackageId) {
      toast.warning("Please select a package price for premium album.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        EventGalleryId: Number(galleryId),
        Name: form.name.trim(),
        IsPremium: form.IsPremium,
        PackageId: form.IsPremium ? Number(form.PackageId) : null,
        MakeGalleryPremium: form.MakeGalleryPremium,
        VisibilityDelayHours: form.visibilityDelayHours !== "" ? Number(form.visibilityDelayHours) : null,
        IsFundRaising: form.IsPremium ? form.isFundraising : false,
        IsWatermark: form.IsWatermark,
        NotifyPromoterOnLive: form.NotifyPromoterOnLive,
        NotifyUsersOnLive: form.NotifyUsersOnLive,
      };

      const res = await createAlbum(payload);
      toast.success(res.data?.Message || "Album created!");
      onCreated(res.data?.Result);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.Message || "Failed to create album.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <div>
            <h3 style={styles.title}>Create New Album</h3>
            <div style={styles.subtitle}>in {galleryName}</div>
          </div>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="Album Name *"
            value={form.name}
            onChange={(e) => set("name", e.target.value)}
            placeholder="e.g. Evening Shots"
            required
          />
          {/*
          <Input
            label="Visibility Delay (hours)"
            type="number"
            value={form.visibilityDelayHours}
            onChange={(e) => set("visibilityDelayHours", e.target.value)}
            placeholder="Leave empty for instant visibility"
          />
          */}

          <div style={styles.checkboxGroup}>
            <label style={styles.checkboxLabel}>
              <input type="checkbox" checked={form.IsWatermark} onChange={(e) => set("IsWatermark", e.target.checked)} />
              <span>Watermark</span>
            </label>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={form.IsPremium}
                onChange={(e) => {
                  const checked = e.target.checked;
                  set("IsPremium", checked);
                  if (!checked) {
                    set("PackageId", "");
                    set("isFundraising", false);
                  }
                }}
              />
              <span>Premium Album</span>
            </label>
            {form.IsPremium && (
              <div style={styles.selectWrap}>
                <label style={styles.selectLabel}>Package Price *</label>
                <select
                  value={form.PackageId}
                  onChange={(e) => set("PackageId", e.target.value)}
                  required={form.IsPremium}
                  style={styles.selectInput}
                >
                  <option value="">Select package price</option>
                  {packages.map((pkg) => (
                    <option key={pkg.Id} value={pkg.Id}>
                      {Number(pkg.DefaultPrice || 0).toFixed(2)} {pkg.Currency}
                    </option>
                  ))}
                </select>
                {packagesLoading && <div style={styles.selectHint}>Loading package prices...</div>}
              </div>
            )}
            {form.IsPremium && (
              <label style={styles.checkboxLabel}>
                <input type="checkbox" checked={form.isFundraising} onChange={(e) => set("isFundraising", e.target.checked)} />
                <span>Donations</span>
              </label>
            )}
            {/*
            <label style={styles.checkboxLabel}>
              <input type="checkbox" checked={form.MakeGalleryPremium} onChange={(e) => set("MakeGalleryPremium", e.target.checked)} />
              <span>Make Gallery Premium</span>
            </label>
            */}
            {/*
            <label style={styles.checkboxLabel}>
              <input type="checkbox" checked={form.NotifyPromoterOnLive} onChange={(e) => set("NotifyPromoterOnLive", e.target.checked)} />
              <span>Notify Promoter on Live</span>
            </label>
            <label style={styles.checkboxLabel}>
              <input type="checkbox" checked={form.NotifyUsersOnLive} onChange={(e) => set("NotifyUsersOnLive", e.target.checked)} />
              <span>Notify Users on Live</span>
            </label>
            */}
          </div>

          <div style={styles.actions}>
            <Button variant="secondary" onClick={onClose} type="button">Cancel</Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Creating..." : "Create Album"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed", inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex", alignItems: "center", justifyContent: "center",
  zIndex: 1000,
};

const modalStyle = {
  background: "#fff",
  borderRadius: 16,
  padding: "28px 32px",
  width: "100%",
  maxWidth: 460,
  boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
};

const styles = {
  header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 },
  title: { margin: "0 0 4px", fontSize: 18, fontWeight: 700, color: "#1e1e2d" },
  subtitle: { fontSize: 13, color: "#888" },
  closeBtn: { background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#888" },
  checkboxGroup: { display: "flex", flexDirection: "column", gap: 10, marginBottom: 24 },
  checkboxLabel: { display: "flex", alignItems: "center", gap: 10, fontSize: 14, color: "#444", cursor: "pointer" },
  selectWrap: { marginTop: 6, marginBottom: 4 },
  selectLabel: { display: "block", marginBottom: 6, fontWeight: 500, fontSize: 14, color: "#444" },
  selectInput: {
    width: "100%",
    padding: "10px 14px",
    border: "1.5px solid #e5e7eb",
    borderRadius: 8,
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
    background: "#fafafa",
  },
  selectHint: { marginTop: 6, fontSize: 12, color: "#888" },
  actions: { display: "flex", justifyContent: "flex-end", gap: 12 },
};

export default CreateAlbumModal;
